/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'download': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<path pid="0" d="M6.284 9.04a.386.386 0 01-.546 0L3.998 7.3a.386.386 0 01.545-.546l1.082 1.082v-6.45a.386.386 0 01.772 0v6.45L7.48 6.754c.15-.15.395-.15.544 0 .151.15.151.395.001.546l-1.74 1.74zm4.33-1.606a.386.386 0 00-.386.386v2.181a.23.23 0 01-.23.23H2a.23.23 0 01-.23-.23V7.819a.386.386 0 00-.771 0v2.488c0 .383.311.693.693.693h8.614a.694.694 0 00.693-.693V7.819a.386.386 0 00-.386-.385z" _stroke="#EC8023" stroke-width=".3" _fill="#EC8023" fill-rule="nonzero"/>'
  }
})
